import { getListTransform } from 'helpers/transformResponse';
import types from './types';

const INITIAL_STATE = {
  list: {
    content: [],
  },
  detail: {},
  statesList: [],
  citiesList: [],
  loading: true,
  buttonLoading: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LIST_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case types.ITEM_DETAIL:
      return {
        ...state,
        detail: action.payload,
        loading: false,
      };
    case types.LIST_LOAD:
      return {
        ...state,
        loading: action.payload,
      };
    case types.BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    case 'STATES_LIST_FETCHED':
      return {
        ...state,
        statesList: action.payload,
        loading: false,
      };
    case 'CITIES_LIST_FETCHED':
      return {
        ...state,
        citiesList: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
